import { Pipe, PipeTransform } from '@angular/core';
import { ITicketSector, IXId } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { BookingTravellerTicketService } from "../../booking-information/components/booking-traveller-card/components/booking-traveller/components/booking-traveller-ticket/services/booking-traveller-ticket.service";

@Pipe({
    name: 'sectorFilter'
})

export class SectorFilterPipe implements PipeTransform {

    constructor(
        private readonly bookingTravellerTicketService: BookingTravellerTicketService,
    ) {
    }
    public transform(sectors: ITicketSector[], sectorArray: IXId[]): ITicketSector[] {
        return this.bookingTravellerTicketService.getFareComponentSectorFilter(
            sectors,
            sectorArray
        );
    }
}